import { Typography } from "@mui/material";
import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { getFridgeId } from "utils/browser/localStorage";
import { getShortenedFridgeId } from "utils/utils";

import UserLeftIllustration from "assets/illustrations/userLeftIllustration.svg";
import { ModalContentWrapper } from "components/primitives/ModalContentWrapper";
import { ModalTitle } from "components/primitives/ModalTitle";

import { BasicModal } from "./BasicModal";
import { ModalSupportFooter } from "./ModalSupportFooter";

type CloseDoorModalProps = {
	toggleButton: ReactElement<{ onClick?: (e: React.MouseEvent<HTMLElement>) => void }>;
};

export const CloseDoorModal = ({ toggleButton }: CloseDoorModalProps) => {
	const fridgeId = getFridgeId();
	const shortenedFridgeId = getShortenedFridgeId(fridgeId);

	return (
		<>
			<BasicModal
				toggleButton={toggleButton}
				fullHeight={true}
				closable={true}
				modalContent={<CloseDoorModalContent fridgeId={shortenedFridgeId} />}
			/>
		</>
	);
};

const CloseDoorModalContent = ({ fridgeId }: { fridgeId: string }) => {
	const { t } = useTranslation();
	return (
		<ModalContentWrapper>
			<ModalTitle variant={"promoHeader"}>{t("modals.openedDoorModal.title")}</ModalTitle>

			<UserLeftIllustration />
			<Typography variant={"cta"} textAlign={"center"} mb={1}>
				{t("modals.openedDoorModal.header")}
			</Typography>
			<Typography variant={"ctaSubtext"} textAlign={"center"} width={"90%"} mb={1}>
				{t("modals.openedDoorModal.body")}
			</Typography>
			<ModalSupportFooter fridgeId={fridgeId} />
		</ModalContentWrapper>
	);
};
